import { render, staticRenderFns } from "./DetailsGoodsInfo.vue?vue&type=template&id=1c722a17&scoped=true&"
import script from "./DetailsGoodsInfo.vue?vue&type=script&lang=js&"
export * from "./DetailsGoodsInfo.vue?vue&type=script&lang=js&"
import style0 from "./DetailsGoodsInfo.vue?vue&type=style&index=0&id=1c722a17&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c722a17",
  null
  
)

export default component.exports